/* eslint-disable no-nested-ternary */
import React from 'react';

import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import BasicInfo from '../../Console/JobManagement/JobTemplates/Template/BasicInfo';
import classes from './styles.module.scss';

const convertDataFieldToDropdownValue = (
  field,
  labelFieldName = 'name',
  isUser,
  isManager
) => {
  if (!field) {
    return '';
  }

  if (isUser) {
    return {
      label: `${field?.userProfile?.fullName} (${
        field?.userProfile?.email || field?.userName
      })`,
      value: field.id,
    };
  }

  if (isManager) {
    return {
      label: `${field.firstName} ${field.lastName}`,
      value: field.id,
    };
  }

  return { label: field[labelFieldName], value: field.id };
};

export default function JobSpecs({ job }) {
  const { t } = useTranslation();

  const basicInfoFormik = useFormik({
    initialValues: {
      userId: !job?.user
        ? ''
        : convertDataFieldToDropdownValue(job.user, null, true),
      company: !job?.company
        ? ''
        : convertDataFieldToDropdownValue(job.company),
      companyManager: !job?.companyManager
        ? ''
        : convertDataFieldToDropdownValue(
            job.companyManager,
            null,
            false,
            true
          ),
      jobTypeIds: !job?.jobTypes
        ? ''
        : job.jobTypes?.map((jobType) =>
            convertDataFieldToDropdownValue(jobType)
          ),
      jobLocationTypeIds: !job?.jobLocationTypes
        ? ''
        : job.jobLocationTypes?.map((jobLocationType) =>
            convertDataFieldToDropdownValue(jobLocationType)
          ),
      jobBenefitIds: !job?.jobBenefits
        ? ''
        : job.jobBenefits?.map((jobBenefit) =>
            convertDataFieldToDropdownValue(jobBenefit)
          ),
      graduation: !job?.graduation
        ? ''
        : convertDataFieldToDropdownValue(job.graduation),
      corporateTitle: !job?.corporateTitle ? '' : job.corporateTitle,
      jobDescription: !job?.jobDescription ? '' : job.jobDescription,
      locationIds: !job?.locations
        ? ''
        : job.locations?.map((loc) => convertDataFieldToDropdownValue(loc)),
      workExperienceId: !job?.workExperience
        ? ''
        : convertDataFieldToDropdownValue(job.workExperience),
      jobPostType: !job?.jobPostType
        ? {
            label: t(
              'dashboardComponents.Console.JobManagement.JobTemplates.Template.BasicInfo.JobPostTypeOptions.Internal'
            ),
            value: 'Internal',
          }
        : {
            label: t(
              `dashboardComponents.Console.JobManagement.JobTemplates.Template.BasicInfo.JobPostTypeOptions.${job.jobPostType}`
            ),
            value: job.jobPostType,
          },
      salaryTo: !job?.salaryTo ? '' : job.salaryTo,
      salaryFrom: !job?.salaryFrom ? '' : job.salaryFrom,
      companyJoiningNote: !job?.companyJoiningNote
        ? ''
        : job.companyJoiningNote,
      companyDescription: !job?.companyDescription
        ? ''
        : job.companyDescription,
      salaryType: !job?.salaryType
        ? {
            value: 'Range',
            label: t(
              'dashboardComponents.Console.JobManagement.JobTemplates.Template.BasicInfo.SalaryTypeOptions.Range'
            ),
          }
        : {
            value: job.salaryType,
            label: t(
              `dashboardComponents.Console.JobManagement.JobTemplates.Template.BasicInfo.SalaryTypeOptions.${job.salaryType}`
            ),
          },
      salaryFrequency: !job?.salaryFrequency
        ? ''
        : {
            value: job.salaryFrequency,
            label: t(
              `dashboardComponents.Console.JobManagement.JobTemplates.Template.BasicInfo.SalaryFrequencyOptions.${job.salaryFrequency}`
            ),
          },
      salaryCurrencyCode: !job?.salaryCurrencyCode
        ? ''
        : { value: job.salaryCurrencyCode, label: job.salaryCurrencyCode },
      note: !job?.note ? '' : job.note,
      coverFileName: !job?.coverFileName ? '' : job.coverFileName,
      jobPostVideoId: !job?.jobPostVideo ? '' : job.jobPostVideo,
      skillIds: !job?.skills
        ? ''
        : job.skills?.map((skill) => convertDataFieldToDropdownValue(skill)),
      jobPostAttachmentIds: !job?.jobPostAttachments
        ? ''
        : job.jobPostAttachments,
      jobTitle: !job?.jobTitle ? '' : job.jobTitle,
      hideCompany: !job?.hideCompany ? false : job.hideCompany,
    },
    onSubmit: () => {},
    enableReinitialize: true,
  });

  return (
    <div className={classes.JobSpecs}>
      <BasicInfo formik={basicInfoFormik} readOnly isEdit={false} isInterview />
    </div>
  );
}
